const WEB_CHUNK_RELOAD_GUARD_KEY = 'tabbio-web-chunk-reload-at';
const WEB_CHUNK_RELOAD_GUARD_TTL_MS = 60_000;

type ReloadStorage = Pick<Storage, 'getItem' | 'setItem'>;

const WEB_CHUNK_LOAD_ERROR_PATTERNS = [
  /ChunkLoadError/i,
  /AsyncRequireError/i,
  /Loading chunk [\w-]+ failed/i,
  // Metro's AsyncRequireError wording on Expo web static exports.
  /Loading module \S+ failed/i,
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /error loading dynamically imported module/i,
  /failed to load.*(?:chunk|\.js)/i,
];

function readErrorText(error: unknown) {
  if (error instanceof Error) {
    return [error.name, error.message, error.stack].filter(Boolean).join('\n');
  }

  if (typeof error === 'string') {
    return error;
  }

  if (error && typeof error === 'object') {
    const record = error as { name?: unknown; message?: unknown; stack?: unknown };
    return [record.name, record.message, record.stack]
      .filter((value): value is string => typeof value === 'string')
      .join('\n');
  }

  return '';
}

export function isWebChunkLoadError(error: unknown) {
  const text = readErrorText(error);
  return WEB_CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(text));
}

export function claimWebChunkReloadSlot(
  storage: ReloadStorage | undefined =
    typeof window !== 'undefined' ? window.sessionStorage : undefined,
  now = Date.now(),
) {
  if (!storage) return false;

  const previous = Number(storage.getItem(WEB_CHUNK_RELOAD_GUARD_KEY));
  if (Number.isFinite(previous) && now - previous < WEB_CHUNK_RELOAD_GUARD_TTL_MS) {
    return false;
  }

  storage.setItem(WEB_CHUNK_RELOAD_GUARD_KEY, String(now));
  return true;
}
